//packages block
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { FC } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
// component block
import { Alert } from "../common/Alert";
import { CustomController } from "../common/CustomController";
// other packages
import { useVerifyEmailAndSetPasswordMutation } from "../../../generated";
import { AUTH_LINKS, BACK_TO_LOGIN, FOLLOW_INSTRUCTIONS, FORBIDDEN_EXCEPTION, ROOT_ROUTE, SAVE, SET_PASSWORD_FAILURE, SET_PASSWORD_FIELDS, SET_PASSWORD_SUCCESS, TOKEN_INVALID } from "../../constants";
import { SetPasswordInput, TokenProps } from "../../interfaceTypes";
import { resetPasswordValidationSchema } from "../../validationSchema";

export const SetPasswordForm: FC<TokenProps> = ({ token }): JSX.Element => {
  const navigate = useNavigate()

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(resetPasswordValidationSchema),

    defaultValues: {
      password: "",
      repeatPassword: ""
    }
  });

  const { handleSubmit, reset } = methods;

  const [VerifyEmailAndSetPassword, { loading }] = useVerifyEmailAndSetPasswordMutation({
    onError({ message }) {
      if (message.toLowerCase() === FORBIDDEN_EXCEPTION) {
        return Alert.error(TOKEN_INVALID)
      }
    },

    onCompleted(data) {
      if (data) {
        const { verifyEmailAndSetPassword: { response } } = data

        if (response) {
          const { status } = response
          if (status) {
            if (status === 404) {
              return Alert.error(SET_PASSWORD_FAILURE);
            }

            if (status === 200) {
              reset()
              Alert.success(SET_PASSWORD_SUCCESS)
              navigate(ROOT_ROUTE)
            }
          }
        }
      }
    }
  })

  const onSubmit: SubmitHandler<SetPasswordInput> = async (data: SetPasswordInput) => {
    if (token) {
      await VerifyEmailAndSetPassword({
        variables: {
          verifyUserAndUpdatePasswordInput: {
            password: data.password,
            token
          }
        }
      });
    }
    else {
      Alert.error(FOLLOW_INSTRUCTIONS)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        {SET_PASSWORD_FIELDS.map((field, index) => {
          const { fieldType, name, title } = field

          return (
            <CustomController
              controllerName={name}
              controllerLabel={title}
              fieldType={fieldType}
              key={index}
            />
          )
        })}

        <Box marginBottom='20px'>
          <Typography component={Link} to={AUTH_LINKS.LOGIN_LINK} color="primary" variant="subtitle1" sx={{ textDecoration: 'underline' }}>
            {BACK_TO_LOGIN}
          </Typography>
        </Box>

        <Button variant="contained" type="submit" fullWidth color="primary" disabled={loading} aria-label={SAVE}
          endIcon={loading && <CircularProgress size={20} color="inherit" />}>
          {SAVE}
        </Button>
      </form>
    </FormProvider>
  )
} 